import React, { useState, useEffect, useRef } from 'react';
import { subscribeDokumente } from '../dokumenteStorage';
import './FotoPickerModal.css';

const FOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const FOTO_MAX_BYTES = 5 * 1024 * 1024;
const FOTO_LIMIT = 3;

export default function FotoPickerModal({ onFotoGewaehlt, onSchliessen }) {
  const [fotos, setFotos] = useState([]);
  const [fehler, setFehler] = useState('');
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const unsub = subscribeDokumente(
      (docs) => setFotos(docs.filter(d => d.kategorie === 'fotos')),
      () => setFotos([]),
    );
    return () => { try { unsub?.(); } catch { /* ignore */ } };
  }, []);

  const handleFileInput = (files) => {
    const file = files?.[0];
    if (!file) return;
    setFehler('');
    if (!FOTO_TYPES.includes(file.type)) {
      setFehler('Nur JPEG, PNG oder WebP erlaubt.');
      return;
    }
    if (file.size > FOTO_MAX_BYTES) {
      setFehler('Datei zu groß (max. 5 MB).');
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    onFotoGewaehlt({ type: 'neu', url: objectUrl, file });
  };

  const handleGalerieFoto = (doc) => {
    onFotoGewaehlt({ type: 'vorhanden', url: doc.url });
  };

  const atLimit = fotos.length >= FOTO_LIMIT;

  return (
    <div className="fpicker-overlay" onClick={onSchliessen}>
      <div className="fpicker-modal" onClick={e => e.stopPropagation()}>
        <div className="fpicker-header">
          <span className="fpicker-title">Bewerbungsfoto wählen</span>
          <button className="fpicker-close" onClick={onSchliessen} aria-label="Schließen">✕</button>
        </div>

        {fotos.length > 0 && (
          <section className="fpicker-section">
            <p className="fpicker-section-label">Meine Fotos</p>
            <div className="fpicker-grid">
              {fotos.map(doc => (
                <button
                  key={doc.id}
                  className="fpicker-thumb"
                  onClick={() => handleGalerieFoto(doc)}
                  title={doc.filename}
                >
                  <img src={doc.url} alt={doc.filename} />
                </button>
              ))}
            </div>
          </section>
        )}

        <section className="fpicker-section">
          <p className="fpicker-section-label">Neues Foto</p>
          {atLimit ? (
            <p className="fpicker-limit-hint">
              Du hast bereits 3 Fotos. Lösche zuerst eines unter <em>Meine Dokumente → Lebenslauf-Fotos</em>.
            </p>
          ) : (
            <div
              className="fpicker-dropzone"
              onClick={() => inputRef.current?.click()}
              role="button"
              tabIndex={0}
              onKeyDown={e => { if (e.key === 'Enter') inputRef.current?.click(); }}
            >
              <input
                ref={inputRef}
                type="file"
                hidden
                accept="image/jpeg,image/png,image/webp"
                onChange={e => handleFileInput(Array.from(e.target.files || []))}
              />
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 16V4m0 0l-4 4m4-4l4 4M4 20h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Foto hochladen <span className="fpicker-hint-text">(JPEG, PNG, WebP · max. 5 MB)</span></span>
            </div>
          )}
          {fehler && <p className="fpicker-error">{fehler}</p>}
        </section>
      </div>
    </div>
  );
}
